<script>
export default Vue.extend({
  props: {
    user: {
      type: Object,
      required: true
    },
    focusedDate: {
      type: String,
      required: true
    },
    dateRange: {
      type: Object,
      required: true
    },
    route: {
      type: String,
      required: true
    }
  },
  computed: {
    minDate() {
      return this.$moment(this.dateRange.start.date).toDate();
    },
    maxDate() {
      return this.$moment(this.dateRange.end.date).toDate();
    }
  },
  data() {
    return {
      defaultCollapsed: false,
      format: "YYYY-MM-DD",
      date: null
    };
  },
  created() {
    this.date = this.$moment.utc(this.focusedDate, this.format).toDate();
  },
  methods: {
    dateChange(date) {
      location = this.route.replace(
        ":date",
        this.$moment(date).format(this.format)
      );
    },
    previousWeek() {
      location = this.route.replace(
        ":date",
        this.$moment(this.date)
          .subtract(1, "weeks")
          .format(this.format)
      );
    },
    nextWeek() {
      location = this.route.replace(
        ":date",
        this.$moment(this.date)
          .add(1, "weeks")
          .format("YYYY-MM-DD")
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Bulma mobile
      this.defaultCollapsed = this.$el.clientWidth > 768;
    });
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/users/Agenda.vue